import { useNavigate } from 'react-router-dom';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { useState } from 'react';
import useAuth from '../../../hooks/useAuth';
import {
  LatePaymentPenalty,
  UpdateContractForm,
} from '../models/contractModel';
import {
  updateContractAdmin,
  updateContractPenaltiesEndpoint,
} from '../services/contractService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

const useContract = () => {
  const navigate = useNavigate();
  const { callEndpoint } = useCallApiAndLoad();
  const [apiErrors, setApiErrors] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const doUpdateContract = async (id: string, payload: UpdateContractForm) => {
    const { data, status } = await callEndpoint(
      updateContractAdmin(payload, id, token),
    );

    const response = fetchResponseAdapter(data);

    if (status === 200) {
      //success
      navigate(0);
    } else {
      //error
      setApiErrors(response.message);
    }
  };

  const doUpdateContractPenalties = async (
    id: string,
    payload: LatePaymentPenalty[],
  ) => {
    const { data, status } = await callEndpoint(
      updateContractPenaltiesEndpoint(
        id,
        {
          penalties: payload,
        },
        token,
      ),
    );

    const response = fetchResponseAdapter(data);

    if (status === 200) {
      //success
      navigate(0);
    } else {
      //error
      setApiErrors(response.message);
    }
  };

  return {
    apiErrors,
    doUpdateContract,
    doUpdateContractPenalties,
  };
};

export default useContract;
